import { AuthService } from 'src/app/base/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { SetPasswordComponent } from '../set-password/set-password.component';

@Component({
    selector: 'app-set-password-standalone',
    templateUrl: './set-password-standalone.component.html',
    styleUrls: ['./set-password-standalone.component.scss'],
    imports: [TitleBarComponent, SetPasswordComponent]
})
export class SetPasswordStandaloneComponent {
  constructor(authService: AuthService) {
    if (authService.isUserLoggedIn()) {
      authService.logout();
    }
  }
}
